import useShowPс from "@/domains/business/hooks/useShowPc";
import BusinessModalsContainer from "@/domains/business/containers/modals/BusinessModalsContainer";
import BusinessPcContainer from "@/domains/business/containers/pc/BusinessPcContainer";

export default function BusinessContainer() {
  const { businessId } = useShowPс();

  return (
    <>
      <BusinessModalsContainer />
      {businessId && <BusinessPcContainer businessId={businessId} />}
    </>
  );
}
